import React from 'react'

import NewDirector from './NewDirector'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewDirectorPage = () => (
  <section>
    <header>
      <PageTitle>New Director</PageTitle>
    </header>
    <NewDirector showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewDirectorPage



// WEBPACK FOOTER //
// ./src/components/Directors/NewDirectorPage.jsx